export default "__VITE_ASSET__CVpxCxvp__"